export enum ATDLNLogicOperator {
  AND,
  OR,
  XOR,
  NOT,
}
